import { GridProps } from 'vibo-ui/List';

export const PLAYLISTS_COLS_COUNT_SM = 4;
export const PLAYLISTS_COLS_COUNT_LG = 5;

// export const PLAYLISTS_ROW_HEIGHT_SM = 238;
// export const PLAYLISTS_ROW_HEIGHT_LG = 275;

// export const PLAYLISTS_COL_WIDTH_SM = 211;
// export const PLAYLISTS_COL_WIDTH_LG = 237;

export const PLAYLISTS_GAP_SM = 12;
export const PLAYLISTS_GAP_LG = 15;

export const LONG_TITLE_SIZE = 34;

export const gridProps: GridProps = {
  columns: [PLAYLISTS_COLS_COUNT_SM, PLAYLISTS_COLS_COUNT_LG],
  gaps: [PLAYLISTS_GAP_SM, PLAYLISTS_GAP_LG],
};
